<template>
  <v-dialog v-model="showDialog" max-width="300" v-if="Object.keys(detailData).length !== 0 && detailData.constructor !== Object" class="semi-transparent-5-bg">
    <v-card class="semi-transparent-7-bg">
        <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->

        <!-- <v-card-text>
            Let Google help apps determine location. This means sending anonymous location data to Google, even when no
            apps are running.
        </v-card-text> -->

        <v-list class="semi-transparent-7-bg">
            <v-list-tile>
                <v-list-tile-avatar>
                    <v-icon class="lighten-1 white--text">fas fa-ticket-alt</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-sub-title> {{ $t( 'reusable.ticket_id' ) }} </v-list-tile-sub-title>
                    <v-list-tile-title>{{detailData[0].id}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider ::inset="true"></v-divider>

            <v-list-tile>
                <v-list-tile-avatar>
                    <v-icon class="lighten-1 white--text">far fa-list-alt</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-sub-title> {{ $t( 'reusable.type' ) }} </v-list-tile-sub-title>
                    <v-list-tile-title>{{getTicketTypeText(detailData[0].ticket_type_id)}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider :inset="true"></v-divider>

            <v-list-tile>
                <v-list-tile-avatar>
                    <v-icon xs class="lighten-1 white--text">fas fa-dice</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-sub-title>{{ $t( 'reusable.product' ) }}</v-list-tile-sub-title>
                    <!-- if deposit / transfer in -->
                    <v-list-tile-title v-if="detailData[0].ticket_type_id == 1 || detailData[0].ticket_type_id == 3 || detailData[0].ticket_type_id == 5">{{detailData[0].product_to.name}}</v-list-tile-title>

                    <!-- if withdraw / transfer out -->
                    <v-list-tile-title v-if="detailData[0].ticket_type_id == 2 || detailData[0].ticket_type_id == 4">{{detailData[0].product_from.name}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider :inset="true"></v-divider>

            <v-list-tile>
                <v-list-tile-avatar>
                    <v-icon xs class="lighten-1 white--text">fas fa-dollar-sign</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-sub-title> {{ $t( 'history.amount' ) }}</v-list-tile-sub-title>
                    <v-list-tile-title>{{detailData[0].amount}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider :inset="true" v-if="detailData[0].ticket_type_id == 1 || detailData[0].ticket_type_id == 2"></v-divider>

            <v-list-tile v-if="detailData[0].ticket_type_id == 1 || detailData[0].ticket_type_id == 2">
                <v-list-tile-avatar>
                    <v-icon xs class="lighten-1 white--text">fas fa-university</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-sub-title> {{ $t( 'reusable.bank' ) }} </v-list-tile-sub-title>

                    <!-- if deposit ticket -->
                    <v-list-tile-title v-if="detailData[0].ticket_type_id == 1">{{detailData[0].bank_acc.code}} {{detailData[0].bank_acc.acc_no}}</v-list-tile-title>

                    <!-- if withdraw ticket -->
                    <v-list-tile-title v-if="detailData[0].ticket_type_id == 2">{{detailData[0].member_bank_acc.bank_acc_name}} {{detailData[0].member_bank_acc.bank_acc_no}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider :inset="true"></v-divider>

            <v-list-tile >
                <v-list-tile-avatar>
                    <v-icon xs class="lighten-1 white--text">fas fa-calendar</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-sub-title> {{ $t( 'reusable.created' ) }} </v-list-tile-sub-title>
                    <v-list-tile-title>{{detailData[0].created_at}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider :inset="true"></v-divider>
            <v-list-tile >
                <v-list-tile-avatar>
                    <v-icon xs class="lighten-1 white--text">fas fa-clipboard-check</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-sub-title> {{ $t( 'history.status' ) }} </v-list-tile-sub-title>
                    <v-list-tile-title v-html="getStatusText(detailData[0].status)"></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider :inset="true"></v-divider>

            <v-list-tile >
                <v-list-tile-avatar>
                    <v-icon xs class="lighten-1 white--text">far fa-comment-dots</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-sub-title> {{ $t( 'reusable.remark' ) }} </v-list-tile-sub-title>
                    <v-list-tile-title>{{ detailData[0].remark }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

        </v-list>

        <v-divider></v-divider>

        <v-card-actions class="semi-transparent-7-bg">
            <v-btn color="green" flat="flat" @click="showDialog = false"> {{ $t( 'reusable.close' ) }} </v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
    hr {
        margin-top: 0px !important;
        margin-bottom: 0px !important;
    }

    div.v-list__tile {
        height: 55px !important;
    }

    .v-list__tile__sub-title {
        font-size: 12px;
    }

    .v-list__tile__title {
        font-size: 16px;
    }
</style>

<script>
export default {
    props: ['dialog', 'detail'],
    data() {
        return {
            showDialog: this.dialog,
            detailData: this.detail
        };
    },
    methods: {
        getStatusText: function(status) {
            let text = status;
            if (status == 'Approved') {
                status = this.$t( 'history.approved' );
                text = '<strong class="text-success">' + status + '</strong>';
            } else if (status == 'Reject') {
                status = this.$t( 'history.reject' );
                text = '<strong class="text-danger">' + status + '</strong>';
            } else if (status == 'New') {
                text = this.$t( 'history.new' );
            } else if (status == 'Verified') {
                text = this.$t( 'history.verified' );
            } else if (status == 'Processing') {
                text = this.$t( 'history.processing' );
            }
            return text;
        },
        getTicketTypeText: function(id) {
            switch(id) {
                case 1:
                    return 'Deposit';
                    break;
                case 2:
                    return 'Withdraw';
                    break;
                case 3:
                    return 'Transfer In';
                    break;
                case 4:
                    return 'Transfer Out';
                    break;
                case 5:
                    return 'Bonus';
                    break;
                default:
                    return id;
                    break;
            }
        }
    },
    watch: {
        dialog(newValue) {
            return this.showDialog = newValue;
        },
        detail(newValue) {
            return this.detailData = newValue;
        },
        showDialog: function(newValue) {
            if (newValue == false) {
                this.$emit('close-dialog')
            }
        }
    }
};
</script>